define(
({
  "alert": "경고",
  "okay": "확인"
})
);
